var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.relevant)?_c('div',{staticClass:"list-group-item",class:_vm.t1,style:({'padding-left': _vm.padding + 'px'}),on:{"click":_vm.gotoElementPage}},[_c('small',{staticClass:"mr-2",domProps:{"innerHTML":_vm._s(_vm.label)}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.showValue))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }